import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { cn } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"
import { useEffect, useRef, useState } from "react"
import { motion } from "motion/react"
import { Button } from "@components/atoms/Button"
import { RotatingLogos } from "@components/motion/RotatingLogos"
import { Appear } from "@components/motion/Appear"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Product Header",
  tags: ["#page"],
}

export default defineBlock("content/product-header", (props) => {
  const theme = props.theme || "slateLight"

  const colors = {
    slateLight: {
      bg1: "bg-slate200",
      bg2: "bg-slate300",
      text: "text-slate950",
    },
    slateMedium: {
      bg1: "bg-slate300",
      bg2: "bg-slate200",
      text: "text-slate950",
    },
    slateDark: {
      bg1: "bg-slate600",
      bg2: "bg-slate300",
      text: "text-slate50",
    },
  }

  const bg1 = colors[theme as keyof typeof colors].bg1
  const bg2 = colors[theme as keyof typeof colors].bg2
  const text = colors[theme as keyof typeof colors].text
  const BottomBar = props.bottomBarLink?.url ? Link : "div"
  const bottomBarProps = props.bottomBarLink?.url
    ? {
        href: props.bottomBarLink.url,
        target: props.bottomBarLink.target || undefined,
        className: "w-full",
      }
    : {}

  return (
    <div className="w-full content-sized my-blockSpace flex flex-col gap-5 md:gap-4">
      <div className="grid grid-cols-2 gap-4">
        <Appear slide>
          <EditableText
            store="title"
            as="p"
            placeholder="Title"
            className="type-sans-3-xl-semibold md:type-sans-4-xl-semibold"
          />
        </Appear>
        <Appear delay={150} className="w-full flex items-center justify-end gap-2">
          {props.primaryButton?.url && (
            <Button variant="orange" href={props.primaryButton.url} target={props.primaryButton.target || undefined}>
              {props.primaryButton.title || "Get Started"}
            </Button>
          )}
          {props.secondaryButton?.url && (
            <Button
              variant="primary"
              href={props.secondaryButton.url}
              target={props.secondaryButton.target || undefined}
            >
              {props.secondaryButton.title || "Explore"}
            </Button>
          )}
        </Appear>
        {/* <RotatingLogos
          logos={props.logos || []}
          itemsPerRotation={3}
          className="w-full items-center justify-end gap-2 h-9 hidden md:flex"
        /> */}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 w-full gap-4">
        <Appear
          delay={300}
          className={cn(
            "w-full rounded-md gap-8 md:gap-0 md:aspect-[520/420] p-5 flex flex-col justify-between",
            bg1,
            text,
          )}
        >
          <Appear slide delay={350}>
            <EditableText
              store="cardTitle"
              as="p"
              className="type-sans-base-semibold md:type-sans-xl-semibold"
              defaultValue="Card Title"
              placeholder="Card Title"
            />
          </Appear>
          <Appear slide delay={450}>
            <EditableText
              store="cardText"
              as="p"
              className="type-serif-lg-regular md:type-serif-2-xl-regular text-pretty"
              defaultValue="This is a description for the card. It provides more details about the card title."
              placeholder="Card Text"
            />
          </Appear>
        </Appear>
        <Appear delay={250} className="w-full rounded-md aspect-[352/256] md:aspect-[520/420] overflow-hidden">
          <Appear delay={250} zoom duration={1000} className="w-full h-full">
            {props.featuredImage?.mediaItemUrl && (
              <ResponsiveImage {...props.featuredImage} className="w-full h-full" objectFit="cover" />
            )}
          </Appear>
        </Appear>
      </div>
      <BottomBar {...bottomBarProps}>
        <Appear
          className={cn(
            "w-full p-7 md:p-6 rounded-md flex flex-col md:flex-row gap-5 md:gap-4 justify-between md:items-center",
            bg2,
          )}
        >
          <EditableText
            store="subtitle"
            as="p"
            className="type-serif-base-regular md:type-serif-lg-regular text-balance"
            defaultValue="This is the subtitle text"
            placeholder="Subtitle Text"
          />
          {props.bottomBarImage?.mediaItemUrl && (
            <ResponsiveImage {...props.bottomBarImage} className="shrink-0 w-9 h-auto" />
          )}
        </Appear>
      </BottomBar>
    </div>
  )
})
